import { Button } from '@madpaws/design-system';
import { useGoogleLogin } from '@react-oauth/google';
import getConfig from 'next/config';
import React from 'react';

import { trackEvent } from '~/components/analytics/analytics';
import { USER_CONTINUE_LOGIN_CLICK_EVENT_NAME } from '~/components/analytics/constants';

import { AuthMethods, GOOGLE_LOGIN_GRANT_TYPE } from '../constants';

import type { CodeResponse } from '@react-oauth/google';
import type { ReactElement } from 'react';

const { publicRuntimeConfig } = getConfig();

type Props = {
  onLoginSuccess: (token: string, authMethod: AuthMethods) => void;
};

export const GoogleLoginButton = ({ onLoginSuccess }: Props): ReactElement => {
  const handleLoginSuccess = (response: CodeResponse): void => {
    onLoginSuccess(response.code, AuthMethods.GOOGLE);
  };

  const loginWithGoogle = useGoogleLogin({
    flow: 'auth-code',
    scope: 'email',
    onSuccess: handleLoginSuccess,
    onError: (error) => console.log(error.error_description),
  });

  const handleGoogleLogin = (): void => {
    trackEvent(USER_CONTINUE_LOGIN_CLICK_EVENT_NAME, { grant_type: GOOGLE_LOGIN_GRANT_TYPE });
    loginWithGoogle();
  };

  return (
    <Button
      iconLeading={
        <img
          alt="google icon"
          src={`${publicRuntimeConfig.staticPath}/icons/sign-in/iconGoogle.svg`}
        />
      }
      isFullBleed
      label="Continue with Google"
      onClick={handleGoogleLogin}
      variant="secondary"
    />
  );
};
